import axios from 'axios';
import * as Sentry from '@sentry/react';

let accessToken: string | null = null;
let refreshPromise: Promise<string> | null = null;

export function setAccessToken(token: string | null) {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export const apiClient = axios.create({ baseURL: '/api' });

apiClient.interceptors.request.use((config) => {
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status >= 500) {
      Sentry.captureException(error, {
        contexts: {
          request: {
            url: error.config?.url,
            method: error.config?.method,
            status: error.response?.status,
          },
        },
      });
    }
    const original = error.config;
    if (error.response?.status !== 401 || original._retry) {
      return Promise.reject(error);
    }
    original._retry = true;

    if (!refreshPromise) {
      refreshPromise = axios
        .post<{ accessToken: string }>('/api/auth/admin/refresh', {}, { withCredentials: true })
        .then((res) => {
          setAccessToken(res.data.accessToken);
          return res.data.accessToken;
        })
        .finally(() => { refreshPromise = null; });
    }

    try {
      const newToken = await refreshPromise;
      original.headers.Authorization = `Bearer ${newToken}`;
      return apiClient(original);
    } catch {
      setAccessToken(null);
      window.location.href = '/login';
      return Promise.reject(error);
    }
  },
);
